/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';

const ObservatorySpaceSvg = ({ color }) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7148 3.85156C21.0485 4.25052 23.5815 11.5568 23.6064 11.6328L23.7285 12.001L23.6055 12.3701C23.586 12.4311 22.5024 15.5345 19.457 17.8076L16.665 12.0283C16.6651 12.0192 16.666 12.0101 16.666 12.001C16.666 10.5139 15.9664 9.1881 14.8799 8.33301L12.7148 3.85156Z" fill={color === 'primary' ? '#2BB1AE' : color === 'transparent' ? 'rgba(255, 255, 255, 0.4)' : 'currentColor'} />
    <path d="M11.998 3.83203C12.2483 3.83203 12.4939 3.83873 12.7344 3.85059L14.9121 8.35742C14.113 7.71678 13.0998 7.33203 11.998 7.33203C9.42447 7.33213 7.33205 9.42543 7.33203 11.999C7.33203 14.5726 9.42446 16.6659 11.998 16.666C14.5717 16.666 16.665 14.5727 16.665 11.999C16.665 11.9941 16.6641 11.9893 16.6641 11.9844L19.4717 17.7949C17.7037 19.119 15.273 20.166 11.998 20.166C11.4493 20.166 10.9242 20.1361 10.4219 20.0811L3.94141 6.66602C5.74484 5.12991 8.34801 3.83207 11.998 3.83203Z" fill={color === 'primary' ? '#2CDDD8' : color === 'transparent' ? 'rgba(255, 255, 255, 0.75)' : 'currentColor'} />
    <path d="M10.4785 20.0869C2.79406 19.2766 0.420777 12.4571 0.391602 12.3691L0.269531 12L0.393555 11.6318C0.408082 11.5855 1.35462 8.85207 3.97949 6.63477L10.4785 20.0869Z" fill={color === 'primary' ? '#7DF3F0' : color === 'transparent' ? '#FFFFFF' : 'currentColor'} />
    <path d="M12.0003 9.66406C10.7357 9.66406 9.66699 10.7327 9.66699 11.9974C9.66699 13.2621 10.7357 14.3307 12.0003 14.3307C13.265 14.3307 14.3337 13.2621 14.3337 11.9974C14.3337 10.7327 13.265 9.66406 12.0003 9.66406Z" fill={color === 'primary' ? '#2CDDD8' : color === 'transparent' ? 'rgba(255, 255, 255, 0.75)' : 'currentColor'} />
  </svg>
);

export const ObservatorySpaceIcon = props => {
  const { color, ...restProps } = props;
  return (
    <Icon
      component={() => <ObservatorySpaceSvg color={color} />}
      {...restProps}
    />
  );
};

ObservatorySpaceSvg.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};

ObservatorySpaceIcon.propTypes = {
  color: PropTypes.oneOf(['primary', 'transparent', 'flat'])
};
